import React, { useEffect } from "react";
import "./_webinar-modal.scss";
import { AnimatePresence, motion } from "framer-motion";
import { X, Calendar, Clock, MapPin } from "lucide-react";

import { HashLink } from "react-router-hash-link";

const WebinarModal = ({ isOpen, setIsOpen }) => {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsOpen(true);
    }, 5000);

    return () => {
      clearTimeout(timeoutId);
      setIsOpen(false);
    };
  }, [setIsOpen]);
  return (
    <>
      <div className="grid place-content-center">
        <SpringModal isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>
    </>
  );
};
const SpringModal = ({ isOpen, setIsOpen }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="modal-overlay">
          <div className="webinar-modal-container">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
            >
              <motion.div
                initial={{ scale: 0, rotate: "12.5deg" }}
                animate={{ scale: 1, rotate: "0deg" }}
                exit={{ scale: 0, rotate: "0deg" }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="webinar-modal-wrapper">
                  {/* <div className="webinar-modal-image-content-wrapper">
                    <div className="webinar-modal-content-wrapper">
                      <div className="webinar-modal-image-content">
                        <p className="webinar-modal-image-content-main-title">
                          Join Us at SME Centre Conference 2024
                        </p>
                        <h2 className="webinar-modal-image-content-title">
                          Unleashing the Potential of AI for Business Growth
                        </h2>
                        <p className="webinar-modal-image-content-text">
                          Sands Expo & Convention Center, Level 3, Jasmine &
                          Hibiscus Ballrooms
                        </p>
                        <div className="webinar-modal-image-content-date">
                          <span>31st July, 9 AM to 4:30 PM</span>
                        </div>
                        <img
                          src="https://cdn.inextlabs.ai/images/Microsoft_SolutionsPartner_DataAIAzure.png"
                          alt="microsft"
                          width={100}
                          className="webinar-modal-image-content-logo"
                          loading="lazy"
                        />
                      </div>
                      <div className="webinar-modal-image-container">
                        <img
                          src="https://eventnook.s3.amazonaws.com/e/75258/_b66a3_website_r7_hp-01-13jpg"
                          alt="amazon"
                          className="webinar-modal-image"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <HashLink
                      target="blank"
                      smooth
                      to="https://www.smecconference.sg/event/smec2024"
                    >
                      <button
                        onClick={() => setIsOpen(false)}
                        className="webinar-modal-content-button button"
                      >
                        Book Your Ticket
                      </button>
                    </HashLink>
                  </div> */}
                  <div className="relative glass-effect rounded-3xl shadow-2xl w-full mx-auto animate-[fadeIn_0.5s_ease-out] overflow-hidden">
                    {/* Close Button */}
                    <button
                      onClick={() => setIsOpen(false)}
                      className="absolute flex right-4 top-4 p-2.5 bg-white/80 hover:bg-white rounded-full transition-all duration-300 z-10 group shadow-lg"
                    >
                      <X className="w-5 h-5 text-[#42526e] group-hover:rotate-90 transition-transform duration-300" />
                    </button>

                    {/* Image Section */}
                    <div
                      className="w-full relative"
                      style={{
                        backgroundImage:
                          "linear-gradient(to right top, #fef7f5, #fef9f9, #fefbfc, #fefdfe, #ffffff)",
                      }}
                    >
                      {/* <div className="absolute inset-0 bg-gradient-to-t from-[#091e42]/50 to-transparent z-[1]" /> */}
                      <img
                        src="https://cdn.inextlabs.ai/images/home/webinar-banner.png"
                        alt="Webinar Banner"
                        className="w-full max-h-64 object-contain"
                      />
                    </div>

                    {/* Content Section */}
                    <div className="p-6 flex webinar-modal-footer">
                      <div className="w-[60%] space-y-4 webinar-modal-footer-content">
                        <h3 className="text-sm font-bold text-[#465382]">
                          Wednesday, 25 June
                        </h3>
                        <h2
                          className="text-4xl font-bold text-[#343e61] "
                          style={{ margin: "0 0 10px 0" }}
                        >
                          Why Voice AI matters ?
                        </h2>
                        <p className="text-[#42526e]">
                          Discover how voice AI is reshaping business with
                          real-time, human-like conversations that automate and
                          elevate CX in 2025.
                        </p>
                        {/* <div className="flex items-center gap-3 text-[#42526e]">
                          <MapPin className="w-5 h-5" />
                          <span>Jasmine & Hibiscus Ballrooms</span>
                        </div> */}
                      </div>
                      {/* New Ticket Box UI */}
                      <div className="mt-6 w-[40%] flex justify-center h-fit webinar-modal-footer-ticket-box">
                        <div className="flex items-center gap-6 bg-white rounded-xl shadow-md px-6 py-4 border border-gray-200">
                          <div>
                            <div className="text-sm font-semibold text-[#42526e]">
                              Free
                            </div>
                            <div className="text-xs text-[#42526e] mt-1">
                              Jun 25 · 10:00 - 11:00 AM
                            </div>
                          </div>
                          <a
                            href="https://events.teams.microsoft.com/event/fa56f9cb-f472-47ea-bffd-6f5b268998e9@a7325f3a-c933-46be-b2ed-2572326475cd"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <button className="bg-[#f05742] text-white font-semibold px-5 py-2 rounded-lg transition-colors duration-200">
                              Register
                            </button>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};
export default WebinarModal;
